/**
 * Helix canvas animation: particles spell "OPENCLAW-LIMEN AI LAB" with 3D projection.
 */
const HELIX_CHARS = ' OPENCLAW'

export function initDna(
  canvas: HTMLCanvasElement | null,
  densityMultiplier = 1,
  alignment = 0.5
): () => void {
  if (!canvas) return () => {}
  const ctx = canvas.getContext('2d')
  if (!ctx) return () => {}
  const c = canvas
  const g = ctx

  let width = 0
  let height = 0
  let t = 0
  const particles: Particle[] = []
  const len = HELIX_CHARS.length
  let animFrameId: number

  function resize() {
    width = c.width = c.offsetWidth || window.innerWidth
    height = c.height = c.offsetHeight || window.innerHeight
  }

  class Particle {
    y: number
    offset: number
    char: string
    x = 0
    screenY = 0
    size = 14
    alpha = 1

    constructor(y: number, offset: number, char: string) {
      this.y = y
      this.offset = offset
      this.char = char
    }

    update(time: number) {
      const angle = this.y * 0.05 + time + this.offset
      const radius = width < 768 ? 80 : 150
      const x3d = Math.sin(angle) * radius
      const z3d = Math.cos(angle) * radius
      const fov = 1000
      const scale = fov / (fov + z3d)
      this.x = width * alignment + x3d * scale
      this.screenY = this.y * 15 * scale + height * 0.1
      this.size = 14 * scale
      this.alpha = scale > 1 ? 1 : 0.4
    }

    draw() {
      g.font = `900 ${this.size}px Helvetica, sans-serif`
      g.fillStyle = `rgba(0,0,0, ${this.alpha})`
      g.textAlign = 'center'
      g.fillText(this.char, this.x, this.screenY)
    }
  }

  for (let i = 0; i < 80 * densityMultiplier; i++) {
    const char = HELIX_CHARS[i % len]
    const pairChar = HELIX_CHARS[(i + Math.floor(len / 2)) % len]
    particles.push(new Particle(i, 0, char))
    particles.push(new Particle(i, Math.PI, pairChar))
  }

  function animate() {
    g.clearRect(0, 0, width, height)
    t += 0.012
    g.strokeStyle = 'rgba(0,0,0,0.2)'
    g.lineWidth = 1
    for (let i = 0; i < particles.length; i += 2) {
      const p1 = particles[i]
      const p2 = particles[i + 1]
      p1.update(t)
      p2.update(t)
      g.beginPath()
      g.moveTo(p1.x, p1.screenY)
      g.lineTo(p2.x, p2.screenY)
      g.stroke()
      p1.draw()
      p2.draw()
    }
    animFrameId = requestAnimationFrame(animate)
  }

  window.addEventListener('resize', resize)
  resize()
  animate()

  return () => {
    window.removeEventListener('resize', resize)
    cancelAnimationFrame(animFrameId)
  }
}
